import React from 'react';

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  status?: 'PENDING' | 'APPROVED' | 'REJECTED' | 'CANCELLED' | 'ESCALATED' | string;
}

export function Badge({ status, className = '', children, ...props }: BadgeProps) {
  let statusClass = 'bg-slate-100 text-slate-700 border-slate-200';
  
  switch (status?.toUpperCase()) {
    case 'PENDING': statusClass = 'badge-pending'; break;
    case 'APPROVED': statusClass = 'badge-approved'; break;
    case 'REJECTED': statusClass = 'badge-rejected'; break;
    case 'CANCELLED': statusClass = 'badge-cancelled'; break;
    case 'ESCALATED': statusClass = 'badge-escalated'; break;
  }

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border ${statusClass} ${className}`}
      {...props}
    >
      {children || status}
    </span>
  );
}

export function LeaveTypeBadge({ colour, name, className = '' }: { colour: string, name: string, className?: string }) {
  return (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-md text-xs font-medium border border-slate-200 bg-slate-50 text-slate-700 ${className}`}>
      <span className="w-2 h-2 rounded-full" style={{ backgroundColor: colour }}></span>
      {name}
    </span>
  );
}
